require('./bootstrap');
require("babel-polyfill");

window.Vue = require('vue');

Vue.prototype.$eventBus = new Vue();

import VueCookies from 'vue-cookies';

import VeeValidate, { Validator } from 'vee-validate';
import $ from 'jquery';
import VueSplide from '@splidejs/vue-splide';
import route from './route'

Vue.use(VueCookies);
Vue.use(VueSplide);

// matomo tag manager analitics script
const analitycsConsented = VueCookies.get("analytics-consent") == null ? false : (VueCookies.get("analytics-consent") == "true" ? true : false);
if (analitycsConsented) {
    // create script element and set attributes
    var _mtm = window._mtm = window._mtm || [];
    _mtm.push({'mtm.startTime': (new Date().getTime()), 'event': 'mtm.Start'});
    const scriptElement = document.createElement("script");
    scriptElement.setAttribute("type", "text/javascript");
    scriptElement.setAttribute("src", "https://matomo.rokus-klett.si/js/container_X68WiSuZ.js");

    document.head.prepend(scriptElement);

    // create noscript element and set attributes
    const noScriptElement = document.createElement("noscript");
    const iframeElement = document.createElement("iframe");
    iframeElement.setAttribute("src", "https://matomo.rokus-klett.si/js/container_X68WiSuZ.js");
    iframeElement.setAttribute("height", "0");
    iframeElement.setAttribute("width", "0");
    iframeElement.setAttribute("style", "display:none;visibility:hidden");
    noScriptElement.appendChild(iframeElement);
    document.body.prepend(noScriptElement);
}


Vue.use(VeeValidate, {
    events: 'change',
    locale: 'sl',
    dictionary: {
      sl: {
          messages: {
              required: () => 'Polje je obvezno',
              email: () => `Zapis e-naslova ni pravilen`,
              digits: () => 'Polje lahko vsebuje le številke (9), brez presledkov'
          }
      }
    }
});

Vue.component('cookie-consent', require('./components/CookieConsent.vue').default);
Vue.component('cookie-consent-details', require('./components/CookieConsentDetails.vue').default);
Vue.component('popup-stack', require('./components/PopupStack.vue').default);
Vue.component('header-template', require('./components/HeaderTemplate.vue').default);

import PopupMaxtura from './components/PopupMaxtura.vue';

import multiRef from './directives/MultiRef';
Vue.directive('multi-ref', multiRef);


Vue.mixin({
	methods: {
		route: route
	}
});

const app = new Vue({
    el: '#app',
    mounted() {
        this.init();
    },
    methods: {
        init() {
            const popupConsented = this.$cookies.get("site-popup-consent") == null ? false : (this.$cookies.get("site-popup-consent") == "true" ? true : false);
            if (popupConsented) {
                this.$root.$emit('add-popup', PopupMaxtura);
            }
        },
        showConsent() {
            this.$eventBus.$emit('show-consent');
        },
        smoothScroll() {
            $('.scroll-link').on('click', function(e) {
                e.preventDefault();
                let href = $(this).attr('href');
                let target = $(href).offset().top;
                $('html, body').stop().animate({scrollTop: target}, 800, 'swing', function() {});
            });
        }
    }
});
